import { BaseDTO } from '../global/base.dto';
import { UserListDTO } from '../user/user-list.dto';

export class DashboardMessageListDTO extends BaseDTO {

    title: string;

    author: UserListDTO;

}
